import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import type { DateTime } from "luxon";

import axiosWrapper from "../../utils/networkWrapper";

type NurseIdToCountOrigin = {
	nurseId: number;
	nurseCount: number;
	lastCalloffTime: DateTime;
};
type NurseIdToCount = {
	[nurseId: number]: { count: number; lastCalloffTime: DateTime };
};

export function useGetCalledOffShiftsThisWeek({
	departmentId,
	periodStart,
	nurseIds,
}: {
	departmentId: string;
	periodStart: DateTime;
	nurseIds: number[];
}): UseQueryResult<NurseIdToCount, Error> {
	return useQuery<NurseIdToCount, Error>({
		queryKey: ["useGetCalledOffShiftsThisWeek", departmentId, periodStart.toSeconds(), nurseIds.toString()],
		queryFn: async () => {
			const searchParams = new URLSearchParams({
				department_id: departmentId,
				period_start: periodStart.toFormat("yyyy-MM-dd"),
			});
			for (const id of nurseIds) {
				searchParams.append("nurse_ids", id.toString());
			}

			const { status, data: nurseIdToCount } = await axiosWrapper<NurseIdToCountOrigin[]>(`/team/call-offs?${searchParams.toString()}`);
			if (status >= 400 || !nurseIdToCount) {
				throw Error("Could not fetch results");
			}

			return nurseIdToCount.reduce<NurseIdToCount>((accu, { nurseId, nurseCount, lastCalloffTime }) => {
				accu[nurseId] = { count: nurseCount, lastCalloffTime };
				return accu;
			}, {});
		},
	});
}
